import _classCallCheck from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
/*
 * EV User Search API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.29
 *
 * Do not edit the class manually.
 *
 */
import { ApiClient } from "../ApiClient";

/**
 * EvAuthApi service.
 * @module api/EvAuthApiApi
 * @version 1.0
 */
export var EvAuthApiApi = /*#__PURE__*/function () {
  /**
    * Constructs a new EvAuthApiApi. 
    * @alias module:api/EvAuthApiApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
  function EvAuthApiApi(apiClient) {
    _classCallCheck(this, EvAuthApiApi);
    this.apiClient = apiClient || ApiClient.instance;
  }

  /**
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/UserSession} and HTTP response
   */
  _createClass(EvAuthApiApi, [{
    key: "apiUserWithHttpInfo",
    value: function apiUserWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = [];
      var accepts = ["application/json;charset=UTF-8"];
      var returnType = Object;
      return this.apiClient.callApi("/rest/public/apiuser", "GET", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/UserSession}
     */
  }, {
    key: "apiUser",
    value: function apiUser() {
      return this.apiUserWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link 'Number'} and HTTP response
     */
  }, {
    key: "getSessionTTLWithHttpInfo",
    value: function getSessionTTLWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ["*/*"];
      var returnType = "Number";
      return this.apiClient.callApi("/rest/public/apiuser/ttl", "GET", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link 'Number'}
     */
  }, {
    key: "getSessionTTL",
    value: function getSessionTTL() {
      return this.getSessionTTLWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Use this link: &lt;a href&#x3D;\&quot;/rest/public/login\&quot;&gt;/rest/public/login&lt;/a&gt; to IP authenticate (no prompt)
     * @param {Object} opts Optional parameters
     * @param {String} opts.error
     * @param {String} opts.force
     * @param {Boolean} opts.api
     * @param {Boolean} opts.prompt
     * @param {Boolean} opts.popup
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
  }, {
    key: "loginWithHttpInfo",
    value: function loginWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        error: opts["error"],
        force: opts["force"],
        api: opts["api"],
        prompt: opts["prompt"],
        popup: opts["popup"]
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ["usersession"];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi("/rest/public/login", "GET", pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType);
    }

    /**
     * Use this link: &lt;a href&#x3D;\&quot;/rest/public/login\&quot;&gt;/rest/public/login&lt;/a&gt; to IP authenticate (no prompt)
     * @param {Object} opts Optional parameters
     * @param {String} opts.error
     * @param {String} opts.force
     * @param {Boolean} opts.api
     * @param {Boolean} opts.prompt
     * @param {Boolean} opts.popup
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "login",
    value: function login(opts) {
      return this.loginWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return EvAuthApiApi;
}();